// equipmentCategories.js
export const EQUIPMENT_CATEGORIES = {
  "categories": {
    "chauffage_ventilation_climatisation": {
      "id": "chauffage_ventilation_climatisation",
      "label": "Chauffage - Ventilation - Climatisation",
      "subcategories": {
        "chauffage_locaux": {
          "id": "chauffage_locaux",
          "label": "Chauffage des locaux",
          "equipment_types": [
            {
              "id": "chaudiere_chauffage_seul",
              "label": "Chaudière chauffage seul",
              "eprel_filters": {
                "product_group_code": "spaceheaters",
                "type": "space_heater_boiler"
              }
            },
            {
              "id": "chaudiere_mixte",
              "label": "Chaudière mixte chauffage + ECS",
              "eprel_filters": {
                "product_group_code": "spaceheaters",
                "type": "combination_heater_boiler"
              }
            },
            {
              "id": "pac_air_eau",
              "label": "Pompe à chaleur air-eau",
              "eprel_filters": {
                "product_group_code": "spaceheaters",
                "type": "heat_pump"
              }
            },
            {
              "id": "pac_basse_temperature",
              "label": "Pompe à chaleur basse température",
              "eprel_filters": {
                "product_group_code": "spaceheaters",
                "type": "low_temp_heat_pump"
              }
            },
            {
              "id": "pac_air_air",
              "label": "Pompe à chaleur air/air",
              "eprel_filters": {
                "product_group_code": "spaceheaters",
                "type": "reversible"
              }
            },
            {
              "id": "chaudiere_cogeneration",
              "label": "Chaudière à cogénération",
              "eprel_filters": {
                "product_group_code": "spaceheaters",
                "type": "cogeneration"
              }
            },
            {
              "id": "radiateur_electrique",
              "label": "Radiateur électrique",
              "eprel_filters": {
                "product_group_code": "localspaceheaters",
                "type": ""
              }
            },
            {
              "id": "poele_granules",
              "label": "Poêle à granulés / bois",
              "eprel_filters": {
                "product_group_code": "solidfuelboilers",
                "type": ""
              }
            },
            {
              "id": "poele_avec_ecs",
              "label": "Poêle avec production ECS",
              "eprel_filters": {
                "product_group_code": "solidfuelboilers",
                "type": "water heating function"
              }
            },
            {
              "id": "poele_cogeneration",
              "label": "Poêle avec cogénération",
              "eprel_filters": {
                "product_group_code": "solidfuelboilers",
                "type": "electricity generation function"
              }
            },
            {
              "id": "pack_chauffage_seul",
              "label": "Pack de chauffage seul",
              "eprel_filters": {
                "product_group_code": "spaceheaterpackages",
                "type": "space_heater_package"
              }
            },
            {
              "id": "pack_chauffage_ecs",
              "label": "Pack de chauffage + ECS",
              "eprel_filters": {
                "product_group_code": "spaceheaterpackages",
                "type": "combination_heater_package"
              }
            },
            {
              "id": "ensemble_poele_granules",
              "label": "Ensemble poêle à granulés",
              "eprel_filters": {
                "product_group_code": "solidfuelboilerpackages",
                "type": ""
              }
            },
            {
              "id": "dispositif_solaire_chauffage",
              "label": "Capteur solaire chauffage",
              "eprel_filters": {
                "product_group_code": "spaceheatersolardevice",
                "type": ""
              }
            },
            {
              "id": "thermostat",
              "label": "Thermostat",
              "eprel_filters": {
                "product_group_code": "spaceheatertemperaturecontrol",
                "type": ""
              }
            }
          ]
        },
        "climatisation": {
          "id": "climatisation",
          "label": "Climatisation",
          "equipment_types": [
            {
              "id": "climatiseur_froid_seul",
              "label": "Climatiseur rafraîchissement",
              "eprel_filters": {
                "product_group_code": "airconditioners",
                "type": "cooling_only"
              }
            },
            {
              "id": "climatiseur_chaud_seul",
              "label": "Climatiseur chauffage",
              "eprel_filters": {
                "product_group_code": "airconditioners",
                "type": "heating_only"
              }
            },
            {
              "id": "climatiseur_reversible",
              "label": "Climatiseur réversible",
              "eprel_filters": {
                "product_group_code": "airconditioners",
                "type": "reversible"
              }
            }
          ]
        },
        "ventilation": {
          "id": "ventilation",
          "label": "Ventilation",
          "equipment_types": [
            {
              "id": "vmc_simple_flux",
              "label": "VMC simple flux",
              "eprel_filters": {
                "product_group_code": "residentialventilationunits",
                "type": "UVU"
              }
            },
            {
              "id": "vmc_double_flux",
              "label": "VMC double flux",
              "eprel_filters": {
                "product_group_code": "residentialventilationunits",
                "type": "BVU"
              }
            },
            {
              "id": "hotte_aspirante",
              "label": "Hotte aspirante",
              "eprel_filters": {
                "product_group_code": "rangehoods",
                "type": ""
              }
            }
          ]
        }
      }
    },
    "eau_chaude_sanitaire": {
      "id": "eau_chaude_sanitaire",
      "label": "Eau Chaude Sanitaire",
      "subcategories": {
        "chauffe_eau": {
          "id": "chauffe_eau",
          "label": "Chauffe-eau",
          "equipment_types": [
            {
              "id": "chauffe_eau_conventionnel",
              "label": "Chauffe-eau conventionnel",
              "eprel_filters": {
                "product_group_code": "waterheaters",
                "type": "conventional"
              }
            },
            {
              "id": "chauffe_eau_thermodynamique",
              "label": "Chauffe-eau thermodynamique",
              "eprel_filters": {
                "product_group_code": "waterheaters",
                "type": "heat_pump"
              }
            },
            {
              "id": "chauffe_eau_solaire",
              "label": "Chauffe-eau solaire",
              "eprel_filters": {
                "product_group_code": "waterheaters",
                "type": "solar"
              }
            },
            {
              "id": "ensemble_chauffe_eau",
              "label": "Ensemble chauffe-eau",
              "eprel_filters": {
                "product_group_code": "waterheaterpackages",
                "type": ""
              }
            },
            {
              "id": "ballon_eau_chaude",
              "label": "Ballon d'eau chaude",
              "eprel_filters": {
                "product_group_code": "hotwaterstoragetanks",
                "type": ""
              }
            },
            {
              "id": "dispositif_solaire_ecs",
              "label": "Capteur solaire ECS",
              "eprel_filters": {
                "product_group_code": "waterheatersolardevices",
                "type": ""
              }
            }
          ]
        }
      }
    },
    "electromenager": {
      "id": "electromenager",
      "label": "Électroménager",
      "subcategories": {
        "cuisson": {
          "id": "cuisson",
          "label": "Cuisson",
          "equipment_types": [
            {
              "id": "four_electrique",
              "label": "Four électrique",
              "eprel_filters": {
                "product_group_code": "ovens",
                "type": "electric_oven"
              }
            },
            {
              "id": "four_gaz",
              "label": "Four gaz",
              "eprel_filters": {
                "product_group_code": "ovens",
                "type": "gas_oven"
              }
            },
            {
              "id": "four_mixte",
              "label": "Four mixte",
              "eprel_filters": {
                "product_group_code": "ovens",
                "type": "mixte_oven"
              }
            }
          ]
        },
        "lavage": {
          "id": "lavage",
          "label": "Lavage",
          "equipment_types": [
            {
              "id": "lave_linge_2019",
              "label": "Lave-linge",
              "eprel_filters": {
                "product_group_code": "washingmachines2019",
                "type": ""
              }
            },
            {
              "id": "lave_linge_ancien",
              "label": "Lave-linge (ancienne réglementation)",
              "eprel_filters": {
                "product_group_code": "washingmachines",
                "type": ""
              }
            },
            {
              "id": "lave_linge_sechant_2019",
              "label": "Lave-linge séchant",
              "eprel_filters": {
                "product_group_code": "washerdriers2019",
                "type": ""
              }
            },
            {
              "id": "lave_linge_sechant_ancien",
              "label": "Lave-linge séchant (ancienne réglementation)",
              "eprel_filters": {
                "product_group_code": "washerdriers",
                "type": ""
              }
            },
            {
              "id": "seche_linge",
              "label": "Sèche-linge",
              "eprel_filters": {
                "product_group_code": "tumbledriers",
                "type": ""
              }
            },
            {
              "id": "seche_linge_recent",
              "label": "Sèche-linge (réglementation récente)",
              "eprel_filters": {
                "product_group_code": "tumbledryers20232534",
                "type": ""
              }
            },
            {
              "id": "lave_vaisselle_2019",
              "label": "Lave-vaisselle",
              "eprel_filters": {
                "product_group_code": "dishwashers2019",
                "type": ""
              }
            },
            {
              "id": "lave_vaisselle_ancien",
              "label": "Lave-vaisselle (ancienne réglementation)",
              "eprel_filters": {
                "product_group_code": "dishwashers",
                "type": ""
              }
            }
          ]
        },
        "froid": {
          "id": "froid",
          "label": "Froid",
          "equipment_types": [
            {
              "id": "refrigerateur_2019",
              "label": "Réfrigérateur domestique",
              "eprel_filters": {
                "product_group_code": "refrigeratingappliances2019",
                "type": ""
              }
            },
            {
              "id": "refrigerateur_ancien",
              "label": "Réfrigérateur domestique (ancienne réglementation)",
              "eprel_filters": {
                "product_group_code": "refrigeratingappliances",
                "type": ""
              }
            },
            {
              "id": "vitrine_refrigeree",
              "label": "Vitrine réfrigérée",
              "eprel_filters": {
                "product_group_code": "refrigeratingappliancesdirectsalesfunction",
                "type": ""
              }
            },
            {
              "id": "armoire_frigorifique_pro",
              "label": "Armoire frigorifique professionnelle",
              "eprel_filters": {
                "product_group_code": "professionalrefrigeratedstoragecabinets",
                "type": ""
              }
            }
          ]
        }
      }
    },
    "eclairage": {
      "id": "eclairage",
      "label": "Éclairage",
      "subcategories": {
        "sources_lumineuses": {
          "id": "sources_lumineuses",
          "label": "Sources lumineuses",
          "equipment_types": [
            {
              "id": "sources_lumineuses",
              "label": "Source lumineuse",
              "eprel_filters": {
                "product_group_code": "lightsources",
                "type": ""
              }
            },
            {
              "id": "lampes_anciennes",
              "label": "Lampe (ancienne réglementation)",
              "eprel_filters": {
                "product_group_code": "lamps",
                "type": ""
              }
            }
          ]
        }
      }
    },
    "electronique": {
      "id": "electronique",
      "label": "Électronique",
      "subcategories": {
        "ecrans_multimedia": {
          "id": "ecrans_multimedia",
          "label": "Écrans et multimédia",
          "equipment_types": [
            {
              "id": "televiseurs",
              "label": "Téléviseurs",
              "eprel_filters": {
                "product_group_code": "electronicdisplays",
                "type": "television"
              }
            },
            {
              "id": "moniteurs",
              "label": "Moniteurs",
              "eprel_filters": {
                "product_group_code": "electronicdisplays",
                "type": "monitor"
              }
            },
            {
              "id": "ecrans_signalisation",
              "label": "Écrans de signalisation",
              "eprel_filters": {
                "product_group_code": "electronicdisplays",
                "type": "signage"
              }
            },
            {
              "id": "autres_ecrans",
              "label": "Autres écrans",
              "eprel_filters": {
                "product_group_code": "electronicdisplays",
                "type": "other"
              }
            },
            // {
            //   "id": "televiseurs_anciens",
            //   "label": "Téléviseur (ancienne réglementation)",
            //   "eprel_filters": {
            //     "product_group_code": "televisions",
            //     "type": ""
            //   }
            // }
          ]
        }
      }
    }
  }
};